module.exports = __webpack_public_path__ + "static/media/RAW-Login_v3.cc57d820.png";